/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import abstractContractClaimTranslations from "./abstractContractClaimTranslations";

const providerContractTranslations = {
  label: "Versorgervertrag",
  reasonForDispute: {
    question: "Welches Problem haben Sie mit Ihrem Anbieter?",
    label: "Problem mit Ihrem Anbieter",
    options: {
      cancellationByProvider: {
        label: "Vertrag wurde von Anbieter gekündigt",
        optionHintText: "Ihr Vertrag wurde ohne Ihre Zustimmung vom Anbieter gekündigt. Sie möchten den Vertrag weiterhin aufrecht erhalten.",
      },
      priceIncrease: {
        label: "Anbieter hat die Preise erhöht",
        optionHintText: "Mein Anbieter hat die Preise oder den Abschlag erhöht - dagegen möchte ich vorgehen.",
      },
      serviceNotAsAgreed: {
        label: "Leistung wird von Anbieter nicht erbracht",
        optionHintText: "Mein Anbieter erbringt seine Leistung nicht wie vertraglich vereinbart.",
      },
      cancellationRefused: {
        label: "Meine Kündigung wird nicht akzeptiert",
        optionHintText: "Sie haben regulär oder außerordentlich gekündigt und der Vertragspartner hat Ihre Kündigung nicht akzeptiert.",
      },
      invoiceIncorrect: {
        label: "Fehlerhafte Rechnung erhalten",
        optionHintText: "Der Anbieter behauptet, dass die Rechnung korrekt ist. Sie möchten sich nun dagegen wehren.",
      },
      other: {
        label: "Anderes Problem oder Frage",
        optionHintText: "Sie können uns Ihr Problem in den folgenden Schritten noch genauer erklären.",
      },
    },
  },
  providerType: {
    question: "Um welche Art des Anbieters geht es?",
    label: "Art des Anbieters",
    options: {
      mobile: { label: "Mobilfunk" },
      dsl: { label: "DSL/Internet" },
      electricity: { label: "Strom" },
      gas: { label: "Gas" },
      other: { label: "Anderer Anbieter" },
    },
  },
  contractNumber: {
    question: "Wie lautet Ihre Kundennummer bei Ihrem Anbieter?",
    label: "Kundennummer",
    helperText: "Sie finden diese Nummer z.B. auf Ihren Rechnungen oder in den E-Mails des Anbieters",
  },
  cancellationDate: {
    question: "Wann haben Sie Ihre Kündigung abgeschickt?",
    label: "Kündigungsdatum",
  },
  cancellationReceivedDate: {
    question: "Wann haben Sie die Kündigung vom Anbieter erhalten?",
    label: "Eingang der Kündigung",
  },
  priceIncreaseAnnouncementDate: {
    question: "Falls Ihr Anbieter die Preiserhöhung angekündigt hat, wann ist diese bei Ihnen eingegangen?",
    label: "Datum Ankündigung Preiserhöhung",
    helperText: "Falls Sie keine Ankündigung erhalten haben, lassen Sie das Feld einfach leer.",
  },
  endOfContractDate: {
    question: "Zu welchem Datum sollte der Vertrag Ihrer Ansicht nach enden?",
    label: "Datum Vertragsende",
  },
  opponentReactionToCancellation: {
    question: "Wie ist die Gegenseite mit Ihrer Kündigung umgegangen?",
    label: "Reaktion Gegenseite auf Kündigung",
    options: {
      noReaction: { label: "Keine Reaktion", optionHintText: "Meine Kündigung wurde ignoriert" },
      cancellationRefused: {
        label: "Kündigung abgelehnt",
        optionHintText: "Meine Kündigung wurde vollständig abgelehnt",
      },
      differentDate: {
        label: "Anderes Kündigungsdatum/Verlängerung",
        optionHintText: "Mir wurde ein anderes Ende des Vertrages genannt oder der Vertrag wurde über das von mir errechnete Vertragsende hinaus verlängert.",
      },
    },
  },
  endOfContractDateOpponent: {
    question: "Zu welchem Datum endet laut Gegenseite Ihr Vertrag?",
    label: "Vertragsende laut Gegenseite",
  },
  ...abstractContractClaimTranslations,
};

export default providerContractTranslations;
